<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="global-locations-title" :field="fields?.title" tag="h2" />
      <JssRichText class="global-locations-subtitle" :field="fields?.subtitle" />
      <div class="global-locations-list">
        <div class="global-locations-list-item" v-for="item in fields?.list" :key="item?.id">
          <AdaptiveMedia class="global-locations-list-item-media" :field="item?.fields?.media" />
          <div
            class="global-locations-list-item-content"
            :style="{ backgroundColor: item?.fields?.backgroundColor?.value }"
          >
            <JssRichText :field="item?.fields?.title" class="global-locations-list-item-title" />
            <JssRichText :field="item?.fields?.desc" class="global-locations-list-item-desc" />
          </div>
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'GlobalLocations',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'global-locations'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.global-locations {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-subtitle {
    font-size: 16px;
    margin-top: 8px;
    text-align: center;
  }

  &-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;

    &-item {
      display: flex;
      flex-direction: column;
      flex: 1;
      border-radius: 12px;
      overflow: hidden;

      &-media {
        width: 100%;
        aspect-ratio: 588 / 352;
      }

      &-content {
        padding: 24px;
      }

      &-title {
        font-size: 24px;
        font-weight: 700;
      }

      &-desc {
        font-size: 14px;
        line-height: 1.4;
        margin-top: 16px;
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-list {
      flex-direction: row;
      margin-top: 40px;
    }
  }
}
</style>
